/** =========================================================
 * Module: config.js
 * App routes and resources configuration
 =========================================================*/


(function () {
  'use strict';

  angular
    .module('app.routes')
    .config(routesConfig);

  routesConfig.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider', 'RouteHelpersProvider'];

  function routesConfig($stateProvider, $locationProvider, $urlRouterProvider, helper) {
    // Set the following to true to enable the HTML5 Mode
    // You may have to set <base> tag in index and a routing configuration in your server
    $locationProvider.html5Mode(false);

    // defaults to dashboard
    $urlRouterProvider.otherwise('/app/projects');

    //
    // Application Routes
    // -----------------------------------
    $stateProvider
      .state('login', {
        url: '/login',
        title: 'Login',
        resolve: helper.resolveFor('icons'),
        templateUrl: helper.basepath('pages/login.html')
      })
      .state('app', {
        url: '/app',
        abstract: true,
        templateUrl: helper.basepath('app.html'),
        resolve: helper.resolveFor('icons', 'ngDialog', 'date-time-picker', 'fancybox', 'localytics.directives', 'infinite-scroll')
      })
      .state('app.page-dashboard', {
        url: '/dashboard',
        title: 'Dashboard',
        controller: 'DashboardController as c',
        resolve: helper.resolveFor('ui.sortable'),
        templateUrl: helper.basepath('pages/dashboard.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-projects', {
        url: '/projects',
        title: 'Projects',
        controller: 'ProjectsController as c',
        resolve: helper.resolveFor('ui.sortable'),
        templateUrl: helper.basepath('pages/projects.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-types', {
        url: '/project-types',
        title: 'Project types',
        controller: 'ProjectTypesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-attributes', {
        url: '/project-attributes',
        title: 'Project attributes',
        controller: 'ProjectAttributesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-parts', {
        url: '/project-parts',
        title: 'Project parts',
        controller: 'ProjectPartsController as c',
        templateUrl: helper.basepath('pages/project-parts.html'),
        resolve: helper.resolveFor('ui.sortable'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-part-types', {
        url: '/project-part-types',
        title: 'Project part types',
        controller: 'ProjectPartTypesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-building-types', {
        url: '/page-project-building-types',
        title: 'Project building types',
        controller: 'ProjectBuildingTypesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-part-act-remark-template-types', {
        url: '/project-part-act-remark-template-types',
        title: 'Project part act remark template types',
        controller: 'ProjectPartActRemarkTemplateTypesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-part-act-remark-templates', {
        url: '/project-part-act-remark-templates',
        title: 'Project part act remark templates',
        controller: 'ProjectPartActRemarkTemplatesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-indicator-templates', {
        url: '/project-indicator-templates',
        title: 'Project indicator templates',
        controller: 'ProjectIndicatorTemplatesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-project-document-templates', {
        url: '/project-document-templates',
        title: 'Project document templates',
        controller: 'ProjectDocumentTemplatesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-customers', {
        url: '/customers',
        title: 'Customers',
        controller: 'CustomersController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-customer-employees', {
        url: '/customer-employees',
        title: 'Customer employees',
        controller: 'CustomerEmployeesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-projectors', {
        url: '/projectors',
        title: 'Projectors',
        controller: 'ProjectorsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-projector-employees', {
        url: '/projector-employees',
        title: 'Projector employees',
        controller: 'ProjectorEmployeesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-contractors', {
        url: '/contractors',
        title: 'Contractors',
        controller: 'ContractorsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-users', {
        url: '/users',
        title: 'Users',
        controller: 'UsersController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-user-certificates', {
        url: '/user_certificates',
        title: 'User certificates',
        controller: 'UserCertificatesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-roles', {
        url: '/roles',
        title: 'Roles',
        controller: 'RolesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-emails', {
        url: '/emails',
        title: 'Emails',
        subTitle: 'Emails sent',
        controller: 'EmailsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-system', {
        url: '/system',
        title: 'System',
        controller: 'SystemController as c',
        templateUrl: helper.basepath('pages/system.html')
      })

    //
    // CUSTOM RESOLVES
    //   Add your own resolves properties
    //   following this object extend
    //   method
    // -----------------------------------
    // .state('app.someroute', {
    //   url: '/some_url',
    //   templateUrl: 'path_to_template.html',
    //   controller: 'someController',
    //   resolve: angular.extend(
    //     helper.resolveFor(), {
    //     // YOUR RESOLVES GO HERE
    //     }
    //   )
    // })
    ;
  } // routesConfig
})();
